import Vue from 'vue';
import {
    UpdatedQueueCallsAnswered,
    UpdatedQueueMembersCount,
    UpdatedQueueMemberCalls,
    UpdatedQueueAgentOffers,
    UpdatedQueueTiers,
    ChangedQueueVisibility,
    UpdatedQueueMetadata,
    UpdateLoadingQueue,
    UpdatedQueueStats,
    UpdateAgentState,
} from '@/store/modules/queue/events';
import { Queue, QueueStateModule, Tier } from '@/store/modules/queue/types';
import { OfferAgent } from '@/store/modules/agent';
import StorageQueueVisibility from '@/core/queues/StorageVisibility';

const mutations = {
    addQueueToContainer(state: QueueStateModule, queue: Queue) {
        Vue.set(state.queuesContainer, queue.name, queue);
    },
    updateQueueCallsAnswered(state: QueueStateModule, { name, callsAnswered }: UpdatedQueueCallsAnswered) {
        const queue = state.queuesContainer[name];
        if (queue.callsAnswered !== callsAnswered) {
            queue.callsAnswered = callsAnswered;
        }
    },
    updateQueueAgentOffers(state: QueueStateModule, { name, agentOffers }: UpdatedQueueAgentOffers) {
        const queue = state.queuesContainer[name];
        queue.agentOffers = new Map(Object.values(agentOffers)
            .map((offer) => [(offer as OfferAgent).agent, offer]));
    },
    updateQueueTiers(state: QueueStateModule, { name, tiers }: UpdatedQueueTiers) {
        tiers.sort((a: Tier, b: Tier) => {
            if (a.agent < b.agent) {
                return 1;
            }
            return -1;
        });
        const queue = state.queuesContainer[name];
        queue.tiers = tiers;
    },
    updateQueueMemberCalls(state: QueueStateModule, { name, memberCalls }: UpdatedQueueMemberCalls) {
        const queue = state.queuesContainer[name];
        queue.memberCalls = new Map(Object.entries(memberCalls));
    },
    updateQueueMembersCount(state: QueueStateModule, { name, membersCount }: UpdatedQueueMembersCount) {
        const queue = state.queuesContainer[name];
        if (queue.membersCount !== membersCount) {
            queue.membersCount = membersCount;
        }
    },
    changeQueueVisibility(state: QueueStateModule, { name, visible }: ChangedQueueVisibility) {
        const queue = state.queuesContainer[name];
        if (queue.visible !== visible) {
            queue.visible = visible;
        }
    },
    changeQueueMetadata(state: QueueStateModule, { name, metadata }: UpdatedQueueMetadata) {
        const queue = state.queuesContainer[name];
        Object.assign(queue.metadata, metadata);
    },
    isLoadingQueue(state: QueueStateModule, { name, isLoading }: UpdateLoadingQueue) {
        const queue = state.queuesContainer[name];
        if (queue.isLoading !== isLoading) {
            queue.isLoading = isLoading;
        }
    },
    updateQueueStats(state: QueueStateModule, { queueStats }: UpdatedQueueStats) {
        queueStats.forEach((stats) => {
            if (state.queuesContainer[stats.callcenter_queue]) {
                const queue = state.queuesContainer[stats.callcenter_queue];
                Vue.set(queue, 'stats', stats);
            }
        });
    },
    setStorageVisibility(state: QueueStateModule, storage: StorageQueueVisibility): void {
        state.storageVisibility = storage;
    },

    updateAgentState(state: QueueStateModule, data: UpdateAgentState): void {
        // el evento puede llegar para una cola que no esta en el contenedor
        // (todavia sin cargar, o fuera de la vista del usuario)
        const queue = state.queuesContainer[data.queueName];

        if (!queue) {
            return;
        }

        const agent = (queue.tiers || []).find((tier) => tier.agent === data.agentName);

        if (agent) agent.state = data.state;
    },
};
export default mutations;
